import {
  getApiBaseUrlWithOrg,
  checkHttpStatus,
  getApiHeadersFromToken
} from '../../utils'

export const fetchActivityResource = async function (
  orgId,
  questId,
  activityId,
  resourceId,
  token
) {
  const url = `${getApiBaseUrlWithOrg(
    orgId
  )}/quests/${questId}/activities/${activityId}/resources/${resourceId}`
  const response = checkHttpStatus(
    await fetch(url, {
      method: 'GET',
      headers: getApiHeadersFromToken(token)
    })
  )

  return response.json()
}



// WEBPACK FOOTER //
// ./src/components/activityedit/API.js